"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipInput = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _ChipGroupContext = require("../ChipGroup/ChipGroupContext.js");
var _index = require("../EncoreProvider/index.js");
var _index2 = require("../Icon/icons/IconX/index.js");
var _index3 = require("../VisuallyHidden/index.js");
var _ChipInput = require("./ChipInput.js");
var _excluded = ["clearIcon", "isInvalid", "onRemove", "removeScreenReaderLabel", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * ChipInput is a removable chip used to display brief user-generated content, such as email addresses.
 * It is meant to be used within a [ChipGroup](https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-chipgroup--docs) component.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-chipinput--docs) |
 * [Encore site](https://encore.spotify.net/web/components/chips) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/ChipInput) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=34892-14611&t=09m9nEoe87Yk6rya-1)
 */
var ChipInput = exports.ChipInput = /*#__PURE__*/_react["default"].forwardRef(function ChipInput(_ref, ref) {
  var clearIcon = _ref.clearIcon,
    isInvalid = _ref.isInvalid,
    onRemove = _ref.onRemove,
    _ref$removeScreenRead = _ref.removeScreenReaderLabel,
    removeScreenReaderLabel = _ref$removeScreenRead === void 0 ? 'Remove' : _ref$removeScreenRead,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_ChipGroupContext.ChipGroupContext),
    handleOnRemove = _useContext.handleOnRemove;
  function handleClick(e, passedOnClick) {
    passedOnClick === null || passedOnClick === void 0 || passedOnClick(e);
    handleOnRemove === null || handleOnRemove === void 0 || handleOnRemove();
    onRemove(e);
  }
  function handleKeyDown(e, passedOnKeyDown) {
    passedOnKeyDown === null || passedOnKeyDown === void 0 || passedOnKeyDown(e);
    if (e.key === 'Backspace' || e.key === 'Delete') {
      handleOnRemove === null || handleOnRemove === void 0 || handleOnRemove();
      onRemove(e);
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_index.EncoreProvider, {
    config: {
      next: ['chip']
    }
  }, /*#__PURE__*/_react["default"].createElement(_ChipInput.ChipInputComponent, Object.assign({
    ref: ref,
    iconTrailing: clearIcon || _index2.IconX,
    "aria-invalid": isInvalid,
    onKeyDown: handleKeyDown,
    onClick: handleClick
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.ChipInput
  }), children, /*#__PURE__*/_react["default"].createElement(_index3.VisuallyHidden, null, " ", removeScreenReaderLabel)));
});